{
	"navigation": {
		"moreLabel": "Más"
	},
	"useDeclarationCreationFormStore": {
		"errorMessages": {
			"fetchDefaultMaterial": "No se pudo recuperar el material",
			"submitDeclaration": "No se pudo enviar la declaración"
		}
	},
	"country": {
		"AC": "Isla Ascensión",
		"AD": "Andorra",
		"AE": "Emiratos Árabes Unidos",
		"AF": "Afganistán",
		"AG": "Antigua y Barbuda",
		"AI": "Anguila",
		"AL": "Albania",
		"AM": "Armenia",
		"AO": "Angola",
		"AQ": "Antártida",
		"AR": "Argentina",
		"AS": "Samoa Americana",
		"AT": "Austria",
		"AU": "Australia",
		"AW": "Aruba",
		"AX": "Islas Aland",
		"AZ": "Azerbaiyán",
		"BA": "Bosnia y Herzegovina",
		"BB": "Barbados",
		"BD": "Bangladesh",
		"BE": "Bélgica",
		"BF": "Burkina Faso",
		"BG": "Bulgaria",
		"BH": "Bahréin",
		"BI": "Burundi",
		"BJ": "Benín",
		"BL": "San Bartolomé",
		"BM": "Islas Bermudas",
		"BN": "Brunéi",
		"BO": "Bolivia",
		"BQ": "Caribe Neerlandés",
		"BR": "Brasil",
		"BS": "Bahamas",
		"BT": "Bután",
		"BV": "Isla Bouvet",
		"BW": "Botsuana",
		"BY": "Bielorrusia",
		"BZ": "Belice",
		"CA": "Canadá",
		"CC": "Isla del Coco",
		"CD": "República Democrática del Congo",
		"CEFTA": "Cefta",
		"CF": "República Centroafricana",
		"CG": "República del Congo",
		"CH": "Suiza",
		"CI": "Costa de Marfil",
		"CK": "Islas Cook",
		"CL": "Chile",
		"CM": "Camerún",
		"CN": "China",
		"CO": "Colombia",
		"CP": "Isla Clipperton",
		"CR": "Costa Rica",
		"CU": "Cuba",
		"CV": "Cabo Verde",
		"CW": "Curazao",
		"CX": "Isla de Navidad",
		"CY": "Chipre",
		"CZ": "República Checa",
		"DE": "Alemania",
		"DG": "Diego García",
		"DJ": "Yibuti",
		"DK": "Dinamarca",
		"DM": "Dominica",
		"DO": "República Dominicana",
		"DZ": "Argelia",
		"ES": "España",
		"EC": "Ecuador",
		"EE": "Estonia",
		"EG": "Egipto",
		"EH": "Sáhara Occidental",
		"ER": "Eritrea",
		"CT": "Cataluña (España)",
		"PV": "País Vasco (España)",
		"ES-TR": "Territorio de España",
		"ET": "Etiopía",
		"EU": "Unión Europea",
		"FI": "Finlandia",
		"FJ": "Fiyi",
		"FK": "Islas Malvinas",
		"FM": "Micronesia",
		"FO": "Islas Feroe",
		"FR": "Francia",
		"GA": "Gabón",
		"ENG": "Inglaterra",
		"NIR": "Irlanda del Norte",
		"SCT": "Escocia",
		"WLS": "Gales",
		"GB": "Gran Bretaña",
		"GD": "Granada",
		"GE": "Georgia",
		"GF": "Guayana Francesa",
		"GG": "Guernesey",
		"GH": "Ghana",
		"GI": "Gibraltar",
		"GL": "Tierra Verde",
		"GM": "Gambia",
		"GN": "Guinea",
		"GP": "Guadalupe",
		"GQ": "Guinea Ecuatorial",
		"GR": "Grecia",
		"GS": "Islas Georgias del Sur y Sandwich del Sur",
		"GT": "Guatemala",
		"GU": "Guam",
		"GW": "Guinea-Bisáu",
		"GY": "Guayana",
		"HK": "Hong Kong",
		"HM": "Islas Heard y McDonald",
		"HN": "Honduras",
		"HR": "Croacia",
		"HT": "Haití",
		"HU": "Hungría",
		"IC": "Canarias",
		"ID": "Indonesia",
		"IE": "Irlanda",
		"IL": "Israel",
		"IM": "Isla de Mann",
		"IN": "India",
		"IO": "Territorio Británico del Océano Índico",
		"IQ": "Irak",
		"IR": "Irán",
		"IS": "Islandia",
		"IT": "Italia",
		"JE": "Jersey",
		"JM": "Jamaica",
		"JO": "Jordán",
		"JP": "Japón",
		"KE": "Kenia",
		"KG": "Kirguistán",
		"KH": "Camboya",
		"KI": "Kiribati",
		"KM": "Comoras",
		"KN": "San Cristóbal y Nieves",
		"KP": "Corea del Norte",
		"KR": "Corea del Sur",
		"KW": "Kuwait",
		"KY": "Islas Caimán",
		"KZ": "Kazajstán",
		"LA": "Laos",
		"LB": "Líbano",
		"LC": "Santa Lucía",
		"LI": "Liechtenstein",
		"LK": "Sri Lanka",
		"LR": "Liberia",
		"LS": "Lesoto",
		"LT": "Lituania",
		"LU": "Luxemburgo",
		"LV": "Letonia",
		"LY": "Libia",
		"MA": "Marruecos",
		"MC": "Mónaco",
		"MD": "Moldavia",
		"ME": "Montenegro",
		"MF": "San Martín",
		"MG": "Madagascar",
		"MH": "Islas Marshall",
		"MK": "Macedonia del Norte",
		"ML": "Malí",
		"MM": "Myanmar (Birmania)",
		"MN": "Mongolia",
		"MO": "Macao",
		"MP": "Islas Marianas del Norte",
		"MQ": "Martinica",
		"MR": "Mauritania",
		"MS": "Montserrat",
		"MT": "Malta",
		"MU": "Mauricio",
		"MV": "Maldivas",
		"MW": "Malaui",
		"MX": "México",
		"MY": "Malasia",
		"MZ": "Mozambique",
		"NA": "Namibia",
		"NC": "Nueva Caledonia",
		"NE": "Níger",
		"NF": "Isla Norfolk",
		"NG": "Nigeria",
		"NI": "Nicaragua",
		"NL": "Países Bajos",
		"NO": "Noruega",
		"NP": "Nepal",
		"NR": "Nauru",
		"NU": "Niue",
		"NZ": "Nueva Zelanda",
		"OM": "Omán",
		"PA": "Panamá",
		"PE": "Perú",
		"PF": "Polinesia Francesa",
		"PG": "Papúa Nueva Guinea",
		"PH": "Filipinas",
		"PK": "Pakistán",
		"PL": "Polonia",
		"PM": "San Pedro y Miquelón",
		"PN": "Islas Pitcairn",
		"PR": "Puerto Rico",
		"PS": "Palestina",
		"PT": "Portugal",
		"PW": "Palaos",
		"PY": "Paraguay",
		"QA": "Katar",
		"RE": "Reunión",
		"RO": "Rumania",
		"RS": "Serbia",
		"RU": "Rusia",
		"RW": "Ruanda",
		"SA": "Arabia Saudita",
		"SB": "Islas Salomón",
		"SC": "Seychelles",
		"SD": "Sudán",
		"SE": "Suecia",
		"SG": "Singapur",
		"SH": "Ascensión de Santa Elena y Tristán da Cunha",
		"SI": "Eslovenia",
		"SJ": "Svalbard y Jan Mayen",
		"SK": "Eslovaquia",
		"SL": "Sierra Leona",
		"SM": "San Marino",
		"SN": "Senegal",
		"SO": "Somalia",
		"SR": "Surinam",
		"SS": "Sudán del Sur",
		"ST": "Santo Tomé y Príncipe",
		"SV": "Salvador",
		"SX": "San Martín",
		"SY": "Siria",
		"SZ": "Suazilandia",
		"SZ-2": "Esuatini",
		"TA": "Tristán da Cunha",
		"TC": "Isla Turcas y Caicos",
		"TD": "Chad",
		"TF": "Tierras Australes y Antárticas Francesas",
		"TG": "Ir",
		"TH": "Tailandia",
		"TJ": "Tayikistán",
		"TK": "Tokelau",
		"TL": "Timor Oriental",
		"TM": "Turkmenistán",
		"TN": "Túnez",
		"TO": "Tonga",
		"TR": "Pavo",
		"TT": "Trinidad y Tobago",
		"TV": "Tuvalu",
		"TW": "Taiwán",
		"TZ": "Tanzania",
		"UA": "Ucrania",
		"UG": "Uganda",
		"US": "EE.UU",
		"UN": "Naciones Unidas",
		"US-2": "A NOSOTROS",
		"UY": "Uruguay",
		"UZ": "Uzbekistán",
		"VA": "Ciudad del Vaticano",
		"VC": "San Vicente y las Granadinas",
		"VE": "Venezuela",
		"VG": "Islas Vírgenes Británicas",
		"VI": "Islas Vírgenes de EE.UU.",
		"VN": "Vietnam",
		"VU": "Vanuatu",
		"WF": "Wallis y Futuna",
		"WS": "Samoa",
		"XK": "Kosovo",
		"YE": "Yemen",
		"YT": "Mayotte",
		"ZA": "Sudáfrica",
		"ZM": "Zambia",
		"ZW": "Zimbabue"
	},
	"languages": {
		"bg-BG": "búlgaro",
		"cs-CZ": "Checo",
		"de-DE": "Alemán",
		"en-US": "Inglés",
		"el-GR": "Griego",
		"es-ES": "Español",
		"fr-FR": "Francés",
		"it-IT": "italiano",
		"nl-NL": "Holandés",
		"no-NO": "Noruego",
		"pl-PL": "Polaco",
		"ro-RO": "rumano",
		"sv-SE": "sueco"
	},
	"traceIdBadge": {
		"traceIdLabel": "ID de seguimiento"
	},
	"units": {
		"kg": "kg",
		"ton": "t",
		"m3": "M3",
		"co2": "CO\u2082 eq.",
		"kgCO2": "kg CO\u2082 eq."
	}
}
